jQuery(document).ready(function($){
    let className = '.featured-product .product-meta__description';
    var str = $(className).html();
    if(typeof str != 'undefined') {
      var newStr = str.slice(0, 6000);
      var len = newStr.lastIndexOf("/p>",6000);
      newStr = str.slice(0, len + 3);
      var removedStr = str.slice(len + 3, str.length);
      $(className).empty().html(newStr);
      $(className).append(' <a href="javascript:void(0);" class="read-more">read more...</a>');
      $(className).append('<span class="more-text">' + removedStr + '</span>');
      $(".read-more").click(function(){
          $('.more-text').show();
          $(this).remove();
      });    
    }
});